import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function find(id: number) {
  const response = await http.getData(`/pasien/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function getIdentitas(rm: number | string) {
  const response = await http.getData(`/pasien/${rm}/identitas`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function updateIdentitas(rm: number | string, data: any) {
  const response = await http
    .putData(`/pasien/${rm}/identitas`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function createIdentitas(data: any) {
  const response = await http.postData(`/pasien`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function createAsuransi(
  rm: number | string,
  data: { asuransiId: string; asuransiNo: string }
) {
  const response = await http
    .postData(`/pasien/${rm}/asuransi`, {
      asuransi_id: data.asuransiId,
      nomor: data.asuransiNo
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function updateAsuransi(
  rm: number | string,
  data: { asuransiId: string; asuransiNo: string }
) {
  const response = await http
    .putData(`/pasien/${rm}/asuransi/${data.asuransiId}`, {
      asuransi_id: data.asuransiId,
      nomor: data.asuransiNo
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getAsuransi(rm: number | string, asuransiId: string) {
  const response = await http
    .getData(`/pasien/${rm}/asuransi/${asuransiId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

function printFormIdentitas(rm) {
  window.open(
    `${http.getAPI().replace("/v1", "")}/pasien/${rm}/form-identitas`,
    "_blank"
  );
}

async function callToDokter(
  registerId: number,
  pasienRm: string,
  unitId: string,
  dokterId: string
) {
  const response = await http
    .postData(`/panggilan-layanan/dokter`, {
      register_id: registerId,
      pasien_rm: pasienRm,
      unit_id: unitId,
      dokter_id: dokterId
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getPasienTag(rm: number | string) {
  const response = await http.getData(`/pasien/${rm}/tag`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function getMultiPasienTag(rm: Array<string | number>) {
  const params = {
    params: {
      rm: rm.join(",")
    }
  };
  const response = await http.getDataParam(`/pasien-tag`, params).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

// sementara: selanjutnya pjindahkan ke service tools/utility/etc yg menaungi general service per unit
// async function getStatusPasien(unitId: string, params = null) {
//   const response = await http.getDataParam(`/unit/${unitId}/general-status-pasien`, params).catch(err => {
//     ErrorAlert.showErrorAlert(err);

//     return Promise.reject(err);
//   });

//   return response.data;
// }

export default {
  find,
  getIdentitas,
  updateIdentitas,
  createIdentitas,
  printFormIdentitas,
  updateAsuransi,
  getAsuransi,
  createAsuransi,
  callToDokter,
  getPasienTag,
  getMultiPasienTag
};
